import type { IFlyerDetailsResources } from "./FlyerDetails.Resources";

export const FlyerDetailsResourcesEn: IFlyerDetailsResources = {
    allOffersBrand: "All {0} promotions",
};
